
interface SidebarItemProps {
    icon: (active: boolean) => React.ReactNode;
    text: string;
    path: string;
    active?: boolean;
    disabled: boolean;
    onClick: () => void;
    collapsed?: boolean;
}

export const SidebarItem = ({
    icon,
    text,
    path,
    active = false,
    disabled = false,
    onClick,
    collapsed = false,
}: SidebarItemProps) => {
    return (
        <div
            onClick={!disabled ? onClick : undefined}
            data-path={path}
            title={collapsed ? text : undefined}
            className={`menu-item flex items-center h-10 rounded-xl transition-all duration-200 ${collapsed ? "justify-center px-0" : "space-x-3 px-4"} ${disabled
                ? "cursor-not-allowed text-gray-400"
                : active
                    ? "bg-[#F7F7F7] text-[#0A0A0A] cursor-pointer"
                    : "text-gray-700 hover:bg-white/60 cursor-pointer"
                }`}
        >
            {icon(active)}
            {!collapsed && (
                <span className={`font-medium text-base ${active ? "text-[#0A0A0A]" : "text-gray-700 opacity-70"}`}>{text}</span>
            )}
        </div>
    );
};